import { useQuery } from "@tanstack/react-query";
import { privateApi } from "./api";
import { getToken } from "./auth.service";
import { UserModel } from "@/types/models";

type TrackingData = {
    user: UserModel;
    // weeks[0] = current week, weeks[i] = i weeks ago
    weeks: number[];
};

const getTrackingData = async () => {
    return await privateApi.get<TrackingData[]>(`/tracking`);
};

export const useTrackingData = () => {
    return useQuery({
        queryKey: ['tracking'],
        queryFn: getTrackingData,
        enabled: !!getToken(),
    });
};